var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2609550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2609558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning-triangle--frame-alert-warning-triangle-exclamation-caution"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 3926",
    d: "M8.68926 1.25285L0.708996 14.9333C0.118881 15.945 0.848584 17.2154 2.01975 17.2154H17.9803C19.1515 17.2154 19.8811 15.945 19.291 14.9333L11.3108 1.25285C10.7252 0.24905 9.27482 0.24905 8.68926 1.25285Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3927",
    d: "M8.68926 1.25285L0.708996 14.9333C0.118881 15.945 0.848584 17.2154 2.01975 17.2154H17.9803C19.1515 17.2154 19.8811 15.945 19.291 14.9333L11.3108 1.25285C10.7252 0.24905 9.27482 0.24905 8.68926 1.25285Z",
    stroke: "#BD5921",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 5.83398V10.7657",
    stroke: "#BD5921",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1111",
    d: "M9.99948 14.1806C9.78997 14.1806 9.62012 14.0108 9.62012 13.8012C9.62012 13.5917 9.78997 13.4219 9.99948 13.4219",
    stroke: "#BD5921",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1112",
    d: "M9.99951 14.1806C10.209 14.1806 10.3789 14.0108 10.3789 13.8012C10.3789 13.5917 10.209 13.4219 9.99951 13.4219",
    stroke: "#BD5921",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.17246374eb8fcc8462b4b823308d46b7.svg";
export { ForwardRef as ReactComponent };